// extracted by mini-css-extract-plugin
export default {"waiting-icon-style":"NotProcessedIcon_waiting-icon-style__Uy3Sy"};